const IN_SEASON_STATUSES = new Set(['REGULAR_SEASON', 'PLAYOFFS']);
const FINISHED_STATUSES = new Set(['COMPLETED', 'REGULAR_SEASON_ENDED']);
const PRE_START_STATUSES = new Set(['PRE_DRAFT', 'ROSTER_INPUT_ACTIVE', 'ROSTERS_SET']);

export const isLeaguePreStart = (status: string | null | undefined): boolean => (
  status != null && PRE_START_STATUSES.has(status)
);

export const isLeagueInSeason = (status: string | null | undefined): boolean => (
  status != null && IN_SEASON_STATUSES.has(status)
);

export const isLeagueFinished = (status: string | null | undefined): boolean => (
  status != null && FINISHED_STATUSES.has(status)
);

/** Active season, upcoming/draft, completed. */
export const leagueDashboardPhaseRank = (status: string | null | undefined): number => {
  if (isLeagueInSeason(status)) return 0;
  if (isLeagueFinished(status)) return 2;
  return 1;
};
